export const GB_CONFIG = {
  code: 'GB',
  name: 'United Kingdom',
  locale: 'en-GB',
  currency: {
    code: 'GBP',
    symbol: '£',
    format: 'en-GB'
  },
  address: {
    format: 'GB',
    hasStateField: false,
    postalCodePattern: /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i,
    regionCode: 'GB',
    requiredFields: ['line1', 'city', 'zipcode'], // No state required for GB
    labels: {
      zipcode: 'Postcode',
      line1: 'Address Line 1',
      line2: 'Address Line 2',
      city: 'Town/City'
    },
    placeholders: {
      line1: 'Enter street address',
      line2: 'Flat, building, etc. (optional)',
      city: 'Enter city',
      zipcode: 'Enter postcode'
    }
  },
  enableViewPlancard: false,
  genderList: [
    {
      key: 'Male',
      value: 'Male',
    },
    {
      key: 'Female',
      value: 'Female',
    },
    {
      key: 'Others',
      value: 'Other',
    },
    {
      key: 'Unspecified',
      value: 'Prefer not to say',
    }
  ],
  biologicalGenderList: [
    {
      key: 'Male',
      value: 'Male',
    },
    {
      key: 'Female',
      value: 'Female',
    },
  ],
  phone: {
    pattern: /^(\+44\s?[1-9a-zA-Z][0-9a-zA-Z]{8,9}|\(?0[1-9a-zA-Z][0-9a-zA-Z]{8,9}\)?|\+44\s?[0-9a-zA-Z]{10,11}|[0-9a-zA-Z]{10,11})$/,
    format: '+44 XXXX XXX XXX',
    placeholder: '+44 7abc 123def',
    countryCode: '+44',
    supportsAlphanumeric: true
  },
  validation: {
    zipcode: {
      pattern: /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}$/i,
      message: 'Please enter a valid GB postcode (e.g., SW1A 1AA)'
    },
    phone: {
      pattern: /^(44([1-9a-zA-Z][0-9a-zA-Z]{8,9})|0[1-9a-zA-Z][0-9a-zA-Z]{8,9}|[1-9a-zA-Z][0-9a-zA-Z]{8,10})$/,
      message: 'Please enter a valid UK phone number (alphanumeric characters allowed)'
    }
  },
  dateFormat: {
    short: 'DD/MM/YYYY',
    long: 'DD MMM, YYYY',
    display: 'en-GB'
  },
  minorAge: 18, // Age below which a responsible party is required (UK: 18 years)
  stripeSecretKey: process.env.REACT_APP_STRIPE_SECRET_KEY_UK,
  terminal: {
    enabled: false,
  },
  biologicalSexRequired: true, // Biological sex is mandatory for GB
  zendeskKey: '72ad5c0d-560a-481c-8e4a-1bb237d4cf86',
  pylonAppId: process.env.REACT_APP_PYLON_APP_ID_UK,
  pylonWidgetUrl: 'https://widget.eu.usepylon.com/widget',
};
